import React, {useEffect} from "react";
import './style.css'
import {styled} from '@mui/material/styles';
import Box from "@mui/material/Box";
import {Grid, LinearProgress, Paper} from "@mui/material";
import {TotalCalls} from "./totalCalls";
import {TotalSms} from "./totalSms";
import {CompletedTasks} from "./completedTasks";
import {OpenTasks} from "./openTasks";
import {ConfirmationCall} from "./ConfirmationCall";
import {AfterDeliveryCall} from "./AfterDeliveryCall ";
import {AfterLDPickupCall} from "./AfterLDPickupCall";
import {useDispatch, useSelector} from "react-redux";
import {getTasksGraphStatistics} from "../../business/redux/reducers/statistics/actions";
import {HeaderMiddleSection} from "../../components/headerSection/headerMiddleSection";

const Item = styled(Paper)(({theme}) => ({
    backgroundColor: '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(2),
    maxHeight: '70vh',
    boxShadow: '0px 10px 20px #0000000D',
    borderRadius: '10px',
    height: 'calc(100% - 32px)'
}));
export const TasksGraph = () => {

    const dispatch = useDispatch();
    const {taskGraphsFilterParams} = useSelector(s => s.filters);

    useEffect(() => {
        document.title = "Account Manager Tasks Graph";
    }, []);

    useEffect(() => {
        dispatch(getTasksGraphStatistics({
            from: taskGraphsFilterParams.from.format('YYYY-MM-DD'),
            to: taskGraphsFilterParams.to.format('YYYY-MM-DD')
        }))
    }, [JSON.stringify(taskGraphsFilterParams)])

    const {statisticsReducer, loading} = useSelector(s => s);

    const {
        total_calls = null,
        total_sms = [],

        completed_tasks = 0,
        not_completed_tasks = 0,

        completed_confirmation_calls = 0,
        not_completed_confirmation_calls = 0,

        completed_after_delivery_calls = 0,
        not_completed_after_delivery_calls = 0,

        completed_after_ld_pickup_calls = 0,
        not_completed_after_ld_pickup_calls = 0,
    } = statisticsReducer;

    const callsData = total_calls ? Object.entries(total_calls).map(([label, value]) => ({label, value})) : []
    const allSmsData = total_sms.map(smsData => ({label: smsData.name, value: smsData.sms_count}))
    const completedTasks = [
        {label: 'Completed', value: Number(completed_tasks)},
        {label: 'Not Completed', value: Number(not_completed_tasks)},
    ]
    const confirmationCalls = [
        {label: 'Completed', value: Number(completed_confirmation_calls)},
        {label: 'Not Completed', value: Number(not_completed_confirmation_calls)},
    ]
    const afterDeliveryCalls = [
        {label: 'Completed', value: Number(completed_after_delivery_calls)},
        {label: 'Not Completed', value: Number(not_completed_after_delivery_calls)},
    ]
    const afterLDPickupCalls = [
        {label: 'Completed', value: Number(completed_after_ld_pickup_calls)},
        {label: 'Not Completed', value: Number(not_completed_after_ld_pickup_calls)},
    ]

    return (
        <>
            <HeaderMiddleSection/>

            <Box sx={{flexGrow: 1, p: 3, background: '#F4F5F8'}}>
                {loading.isLoading
                    ? <LinearProgress/>
                    : <Grid container spacing={3} direction="row" sx={{
                        alignItems: "stretch",
                    }}>
                        <Grid item xs={6}>
                            <Item>
                                <TotalCalls callsData={callsData}/>
                            </Item>
                        </Grid>
                        <Grid item xs={6}>
                            <Item>
                                <TotalSms allSmsData={allSmsData}/>
                            </Item>
                        </Grid>
                        <Grid item xs={6}>
                            <Item>
                                <CompletedTasks completedTasks={completedTasks}/>
                            </Item>
                        </Grid>
                        <Grid item xs={6}>
                            <Item>
                                <ConfirmationCall confirmationCalls={confirmationCalls}/>
                            </Item>
                        </Grid>
                        <Grid item xs={12}>
                            <Item>
                                <OpenTasks/>
                            </Item>
                        </Grid>
                        <Grid item xs={6}>
                            <Item>
                                <AfterDeliveryCall afterDeliveryCalls={afterDeliveryCalls}/>
                            </Item>
                        </Grid>
                        <Grid item xs={6}>
                            <Item>
                                <AfterLDPickupCall afterLDPickupCalls={afterLDPickupCalls}/>
                            </Item>
                        </Grid>
                    </Grid>}
            </Box>
        </>
    )
}
